import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/tlChannels/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/tlChannels/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/tlChannels/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/tlChannels/delete',
    method: 'post',
    data
  })
}


export function block(data) {
  return request({
    url: '/tlChannels/block',
    method: 'post',
    data
  })
}


export function restore(data) {
  return request({
    url: '/tlChannels/restore',
    method: 'post',
    data
  })
}


export function dismiss(data) {
  return request({
    url: '/tlChannels/dismiss',
    method: 'post',
    data
  })
}